/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var DemoOutcome;

(function (DemoOutcome) {
  DemoOutcome["INTERESTED"] = "interested";
  DemoOutcome["NOT_INTERESTED"] = "not_interested";
  DemoOutcome["NOT_RELEVANT"] = "not_relevant";
})(DemoOutcome || (DemoOutcome = {}));